// test498
(498 && 0);
